import React, { Component } from 'react'
import './Header.scss'

class Header extends Component {
  render() {
    return (
      <div className="header">
        <h1>Rate My DIY</h1>
      </div>
    )
  }
}

export default Header
